import * as ActionTypes from '../actions/currencies';
import initialState from './initialState';
import { errorResponseHandler } from '../utils/error-utils';

export default (state = initialState.currencies, action) => {
  const { payload, type } = action;

  switch (type) {
    case ActionTypes.LIST_CURRENCIES:
    case ActionTypes.LIST_CURRENCIES_PENDING:
      return { ...state, loadingCurrencies: true };

    case ActionTypes.LIST_CURRENCIES_REJECTED:
      return {
        ...state,
        error: true,
        loadingCurrencies: false,
        ...errorResponseHandler(payload, 'ListCurrencies')
      };

    case ActionTypes.LIST_CURRENCIES_FULFILLED:
      return {
        ...state,
        currencies: payload.data,
        success: true,
        loadingCurrencies: false,
        message: 'Data Fetched Successfully'
      };

    case ActionTypes.LIST_CURRENCY_RATES:
    case ActionTypes.LIST_CURRENCY_RATES_PENDING:
      return { ...state, loadingRates: true };

    case ActionTypes.LIST_CURRENCY_RATES_REJECTED:
      return {
        ...state,
        error: true,
        loadingRates: false,
        ...errorResponseHandler(payload, 'ListCurrencyRates')
      };

    case ActionTypes.LIST_CURRENCY_RATES_FULFILLED:
      return {
        ...state,
        rates: payload.data,
        success: true,
        loadingRates: false,
        message: 'Currency Rates Fetched Successfully'
      };

    case ActionTypes.FETCH_CURRENCY_RATE:
    case ActionTypes.FETCH_CURRENCY_RATE_PENDING:
      return { ...state, fetchRates: true };

    case ActionTypes.FETCH_CURRENCY_RATE_REJECTED:
      return {
        ...state,
        fetchRates: false,
        ...errorResponseHandler(payload, 'FetchCurrencyRate')
      };

    case ActionTypes.FETCH_CURRENCY_RATE_FULFILLED:
      return { ...state, currencyRate: payload.data, fetchRates: false };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/currencies.js